/**
 * DreamPay Private API
 * Private API v2 - Current version with JWT authentication, role-based access control, and enhanced security features.
 *
 * The version of the OpenAPI document: v2
 * Contact: suporte@dreampay.com.br
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type ReconcileActionTypeV2 = 'Accept' | 'AcceptAndUpdate' | 'Ignore' | 'ManualMatch';

export const ReconcileActionTypeV2 = {
  Accept: 'Accept' as ReconcileActionTypeV2,
  AcceptAndUpdate: 'AcceptAndUpdate' as ReconcileActionTypeV2,
  Ignore: 'Ignore' as ReconcileActionTypeV2,
  ManualMatch: 'ManualMatch' as ReconcileActionTypeV2,
};
